import { Search, X } from "lucide-react";

interface SearchbarProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
}

export default function Searchbar({
  value,
  onChange,
  placeholder = "Search...",
  className = "",
}: SearchbarProps) {
  return (
    <div
      className={`flex-1 flex items-center gap-3 bg-white rounded-2xl border border-slate-200 px-4 shadow-sm focus-within:border-violet-400 focus-within:ring-2 focus-within:ring-violet-50 transition-all ${className}`}
    >
      <Search className="w-4 h-4 text-slate-400 flex-shrink-0" />
      <input
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className="flex-1 py-3 bg-transparent outline-none text-slate-800 text-[14px] placeholder-slate-400"
        style={{ fontFamily: "Inter, sans-serif", fontWeight: 400 }}
      />
      {value && (
        <button
          onClick={() => onChange("")}
          className="text-slate-400 hover:text-slate-600"
        >
          <X className="w-4 h-4" />
        </button>
      )}
    </div>
  );
}
